import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { paragraphRegular } from '@helpers/typography';
import styled, { css } from 'styled-components';
export const CommonTextInputStyles = css `
  ${fonts.proximaNova.regular};

  --bgColour: ${brand.global.white};
  --borderRadius: 10px;
  --placeholderColour: ${brand.grey.dark};
  --readOnlyColour: ${brand.grey.dark};

  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  display: block;
  background: var(--bgColour);
  border: 1px solid var(--borderColour);
  border-radius: var(--borderRadius);
  color: var(--textColour);
  height: ${fluid(48, 55)};
  font-size: 16px;
  line-height: 26px;
  margin: 0;
  padding: ${fluid(10, 14)} 12px;
  width: 100%;
  scroll-margin: calc(var(--headerHeight, 0px) + ${fluid(16, 32)}) 0 0;

  &:disabled {
    opacity: 0.5;
    color: var(--readOnlyColour);
    cursor: not-allowed;
  }

  &:read-only,
  &[readonly] {
    color: var(--readOnlyColour);
  }

  &::placeholder {
    color: var(--placeholderColour);
    opacity: 0.5;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-text-fill-color: var(--textColour);
    -webkit-box-shadow: 0 0 0px 1000px ${brand.green.light} inset;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-style: solid;
  }
`;
const Input = styled.input `
  ${CommonTextInputStyles};
`;
const AdditionalElementStyles = css `
  ${paragraphRegular};
  ${fonts.proximaNova.bold};

  --borderRadius: 10px;

  display: flex;
  align-items: center;
  height: ${fluid(48, 55)};
  border: 1px solid var(--borderColour);
  padding: 0 ${fluid(16, 24)};
  background-color: ${brand.green.light};
  color: var(--textColour);
  white-space: nowrap;
  margin: 0;
`;
const Prefix = styled.span `
  ${AdditionalElementStyles};

  border-right: 0;
  border-radius: var(--borderRadius) 0 0 var(--borderRadius);
`;
const Suffix = styled.span `
  ${AdditionalElementStyles};

  border-left: 0;
  border-radius: 0 var(--borderRadius) var(--borderRadius) 0;
`;
const InputWrapper = styled.div `
  display: flex;

  &[data-type='currency'] {
    > input {
      ${CommonTextInputStyles};
    }
  }

  &:has(${Prefix}) {
    input {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  &:has(${Suffix}) {
    input {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`;
const TextboxStyles = {
    Input,
    InputWrapper,
    Prefix,
    Suffix,
};
export default TextboxStyles;
